// Kart Teslim Al (kulüp girişi kart iadesi / depozito iadesi) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.cardReturn';

export const salesCardReturnGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kart nasıl teslim alınır?'),
  intro: t(`${G}.intro`, 'Kulüp girişinde verilen kartları geri alırsınız; varsa depozito ve karttaki nakit bakiye iade edilir, kartın oturumu kapatılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kart okutma ve kart tablosu'),
    footer: t(`${G}.regions.footer`, 'Teslim / iade düğmeleri'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Müşteri kartı geri getirdiğinde kartı teslim alırsınız. Kart için depozito alındıysa depozito iade edilir; depozito yoksa veya daha önce iade edildiyse kart yalnızca teslim alınır. Kartın açık oturumu her durumda kapatılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kartları okutun'),
      text: t(`${G}.s2.text`, 'Kartı okutun veya "Kart UID" kutusuna yazıp Enter\'a ya da "Ara"ya basın. Aynı satışta verilen tüm kartlar tabloda listelenir. Teslim edilecek diğer kartları "Kartları okutun" kutusuna okutup "Ekle"ye basın; okutulan kartlar "Teslim" sütununda yeşil işaretlenir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yalnız okuttuğunuz kartlar teslim alınır; "Okutulmadı" yazan kartlar aktif kalır.'),
        t(`${G}.s2.tip2`, 'Başka bir satışa ait kart okutulursa "Bu kart bu satışa ait değil" uyarısı çıkar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Depozito iadesi mi, sadece teslim mi?'),
      text: t(`${G}.s3.text`, '"İade İşlemi" sütunu her kartta ne olacağını söyler: "₺… nakit deposito iade", "₺… POS deposito iade", "Sadece teslim" (depozito yok) veya "Deposito daha önce iade edilmiş". Kartta nakit yüklenmiş bakiye varsa "+ ₺… nakit bakiye iade" yazar; bu bakiye de nakit iade edilir. "İade Özeti" toplam tutarları gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Nakit depozito ve nakit bakiye tutarını müşteriye nakit ödeyin; sistem depozitoyu "iade edildi" olarak işaretler, bakiyeyi karttan düşer.'),
        t(`${G}.s3.tip2`, '"Konum" kartın içeride mi dışarıda mı olduğunu ve son geçiş saatini gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. POS ile ilgili kurallar'),
      text: t(`${G}.s4.text`, 'Kartta POS ile yüklenmiş bakiye varsa bu ekrandan iade yapılamaz ve teslim düğmesi görünmez. Önce PYK Ekranından kart bakiye iadesini yapın, ardından kartı teslim alın.'),
      tips: [
        t(`${G}.s4.tip1`, 'POS ile alınan depozitonun iadesi için ödemede kullanılan aynı banka/kredi kartı müşteride olmalıdır.'),
        t(`${G}.s4.tip2`, 'Depozito iadesi yalnız gün sonu yapılmadan önce yapılabilir; gün sonu alındıysa iade alınamaz.'),
        t(`${G}.s4.tip3`, 'Depozito POS ile alınmış ama Pavo satış numarası yoksa otomatik iade yapılamaz; kart teslim alınır, depozitoyu elle iade etmeniz gerekir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Teslim alın ve iade edin'),
      text: t(`${G}.s5.text`, 'Tek tür iade varsa "N Kartı Teslim Al (₺… İade)" düğmesi hepsini bir kerede yapar. Hem nakit hem POS depozito varsa iki adım vardır: önce "Nakit İade + Teslim Al", sonra "POS Deposito İade". POS depozitosu, Pavo\'daki depozito satışı iptal edilerek müşterinin kartına iade edilir; aynı depozito satışındaki kartlar tek iptalle birlikte iade edilir.'),
      tips: [
        t(`${G}.s5.tip1`, 'POS depozito iptali başarısız olursa kart teslim alınmaz ve aktif kalır; tekrar deneyebilirsiniz.'),
        t(`${G}.s5.tip2`, '"Satış bulunamadı" hatası, satış cihaz çevrimdışıyken kesildiyse görülebilir; cihaz internete bağlanıp senkron olduktan sonra tekrar deneyin.'),
        t(`${G}.s5.tip3`, 'Sonuçlar kart kart listelenir; hepsi başarılıysa pencere kendiliğinden kapanır.'),
      ],
    },
  ],
});
